/* DEMO (30 Oct): basket page. (1) quantities update by themselves (about a second after the last change; Enter updates instead of going to checkout), (2) header button keeps its 'Checkout' name on this page but now has the basket icon on phones (it showed a blank circle), (3) Back link uses the browser history when there is one, (4) the LimeSpot 'Recently viewed items' strip is moved below the Checkout buttons (it used to sit between the items and the total). */
(function () {
  'use strict';
  if (window.__dcCart) return;
  window.__dcCart = 1;
  var lab = document.querySelector('#main-nav-basket a > span');
  if (lab && /checkout/i.test(lab.textContent)) { lab.className = 'note'; lab.innerHTML = '<i class="fa fa-shopping-basket" aria-hidden="true"></i> Checkout'; }
  var back = document.querySelector('.dc-back');
  if (back) back.addEventListener('click', function (e) { if (window.history.length > 1) { e.preventDefault(); window.history.back(); } });
  var form = document.querySelector('form.cart');
  if (!form) return;

  function moveRecent() {
    var boxes = [].slice.call(document.querySelectorAll('limespot-box, .ls-recommendation-box'));
    var moved = false;
    boxes.forEach(function (b) {
      if (b.getAttribute('data-dc-moved') || b.parentNode === form.parentNode && b.previousElementSibling === form) return;
      if (!/recently viewed/i.test((b.textContent || '').slice(0, 300))) return;
      var slot = b.closest('limespot-slot');
      var node = (slot && !slot.contains(form)) ? slot : b;
      node.setAttribute('data-dc-moved', '1');
      b.setAttribute('data-dc-moved', '1');
      node.classList.add('dc-recent');
      form.parentNode.insertBefore(node, form.nextSibling);
      moved = true;
    });
    return moved;
  }
  moveRecent();
  if (window.MutationObserver) {
    var mo = new MutationObserver(function () { moveRecent(); });
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 20000);
  }

  var SEL = 'input[name="updates[]"]';
  var t = null, busy = false;
  function changed() {
    return [].slice.call(form.querySelectorAll(SEL)).some(function (i) { return String(i.value) !== String(i.defaultValue); });
  }
  function send() {
    if (busy || !changed()) return;
    busy = true;
    var h = document.createElement('input'); h.type = 'hidden'; h.name = 'update'; h.value = 'Update'; form.appendChild(h);
    form.classList.add('dc-updating');
    form.submit();
  }
  function soon() { clearTimeout(t); t = setTimeout(send, 900); }
  form.addEventListener('change', function (e) { if (e.target.matches && e.target.matches(SEL)) soon(); });
  form.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('.js-qty, .cart-item-qty')) setTimeout(function () { if (changed()) soon(); }, 80); });
  form.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches && e.target.matches(SEL)) { e.preventDefault(); if (changed()) send(); }
  });
})();